import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ItdcrStep } from 'src/app/shared/models/data/itdcrVisualOverwiev.model';
import { BackendService } from 'src/app/shared/services/backend/backend.service';
import { TeiasoftLoaderService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-loader.service';
import { Globals } from 'src/app/shared/globals/globals';

@Component({
  selector: 'app-modal-itdcr-visual-overview',
  templateUrl: './modal-itdcr-visual-overview.component.html',
  styleUrl: './modal-itdcr-visual-overview.component.scss'
})
export class ModalItdcrVisualOverviewComponent implements OnInit {

  @Input() itdcrNo!: string;
  @Output() onClose = new EventEmitter<void>();

  steps: ItdcrStep[] = [];
  @ViewChild('notesTpl') notesTpl!: TemplateRef<any>;


  constructor(
    private backendService: BackendService,
    private loaderService: TeiasoftLoaderService,
    private dialog: MatDialog,
    public globals: Globals
  ) {

  }

  ngOnInit(): void {
    this.loadVisualOverview();
  }

  loadVisualOverview(): void {
    this.loaderService.start();
    this.backendService.getItdcrVisualOverwievInfo(this.itdcrNo).subscribe({
      next:
        res => {
          this.loaderService.stop();
          this.steps = res.itdcrSteps || [];
        },
      complete: () => this.loaderService.stop()
    });
  }

  onCloseClick() {
    this.onClose.emit();
  }

  statusClass(status?: string): string {
    const key = (status || '').toLowerCase();
    if (['completed'].includes(key)) return 'flow-status--done';
    if (['inprogress'].includes(key)) return 'flow-status--inprogress';
    return '';
  }

  openNotes(notes?: string, title?: string) {
    if (!notes) return;
    this.dialog.open(this.notesTpl, {
      data: { notes, title },
      width: '600px',
      autoFocus: false
    });
  }


}
